<script lang="ts">
    export let header: boolean = false;
</script>

<li class={header ? "collection-header" : "collection-item"}><slot /></li>
